import { ListGroup } from "react-bootstrap";
import type { NetworkTemplate } from "@models/networkTemplate.model";

interface NetworkTemplateListProps {
  templates: NetworkTemplate[];
  selectedId: number | null;
  onSelect: (template: NetworkTemplate) => void;
}

export const NetworkTemplateList = ({ templates, selectedId, onSelect }: NetworkTemplateListProps) => {
  if (templates.length === 0) {
    return (
      <div className="p-3 text-muted">
        <small>No network templates found.</small>
      </div>
    );
  }

  return (
    <ListGroup variant="flush" className="h-100" style={{ overflowY: "auto" }}>
      {templates.map((template) => (
        <ListGroup.Item
          key={template.id}
          action
          active={template.id === selectedId}
          onClick={() => onSelect(template)}
          className="d-flex flex-column align-items-start"
        >
          <span className="fw-semibold">{template.name}</span>
          <small className={template.id === selectedId ? "text-white-50" : "text-muted"}>
            {template.network}
          </small>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};
